module.exports = __webpack_public_path__ + "img/carpet.0c5798e6.jpg";